import useAppParamsAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useAppParamsAlertNotificationListener';
import useEventEmitterAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useEventEmitterAlertNotificationListener';

export default function useAlertNotificationListener() {
	useAppParamsAlertNotificationListener();
	useEventEmitterAlertNotificationListener();
}
